import type {DiffEntryDataWithExtraInfo} from '../../types/commit-types'
import {Diff} from './Diff'
import {DiffsHeader} from './DiffsHeader'
import {useDiffViewSettings} from '../../contexts/DiffViewSettingsContext'

interface DiffsProps {
  setTreeExpanded: (treeExpanded: boolean) => void
  treeExpanded: boolean
  treeEnabled: boolean
  diffEntryData: DiffEntryDataWithExtraInfo[]
  contextLinePathURL: string
}
export function Diffs({setTreeExpanded, treeExpanded, treeEnabled, diffEntryData, contextLinePathURL}: DiffsProps) {
  const diffViewSettings = useDiffViewSettings()

  return (
    <div data-hpc>
      <DiffsHeader setTreeExpanded={setTreeExpanded} treeExpanded={treeExpanded} treeEnabled={treeEnabled} />

      {diffEntryData.map((currentDiffData, index) => {
        return (
          <div key={`key-make-this-better-than-index-TODO-${index}`} className="pt-2 pb-2">
            <Diff
              diffEntryData={currentDiffData}
              splitPreference={diffViewSettings.splitPreference}
              contextLinePathURL={contextLinePathURL}
            />
          </div>
        )
      })}
    </div>
  )
}

try{ Diffs.displayName ||= 'Diffs' } catch {}